import React from "react"
import { Link } from "gatsby"

import Author from "../components/author"
import PrevNext from "../components/prev-next"
import RelatedPosts from "./related-posts"

const PostFooter = ({ frontmatter, pageContext, relatedPosts }) => {
  return (
    <footer className="p-entry__foot">
      <div className="c-postMetas u-flex--aicw">
        <div className="c-postTerms u-flex--aicw">
          <div className="c-postTerms__item -category u-flex--aicw">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              className="arkhe-svg-folder c-postMetas__icon"
              width="1em"
              height="1em"
              viewBox="0 0 40 40"
              role="img"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M15.2,8l3.6,3.6H35V32H5V8H15.2 M16.4,5H2v30h36V8.6H20L16.4,5L16.4,5z" />
            </svg>{" "}
            <Link
              className="c-postTerms__link"
              to={`/category/${frontmatter.categories[0].slug}/`}
            >
              {frontmatter.categories[0].title}
            </Link>
          </div>
          {frontmatter.tags?.length > 0 && (
            <div className="c-postTerms__item -tag u-flex--aicw">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                className="arkhe-svg-tag c-postMetas__icon"
                width="1em"
                height="1em"
                viewBox="0 0 40 40"
                role="img"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M9.3,8.3c-1.2,1.2-1.2,3.3,0,4.5c1.3,1.3,3.3,1.3,4.5,0s1.3-3.3,0-4.5C12.6,7.1,10.5,7.1,9.3,8.3z" />
                <path d="M20.9,2l-0.3-0.3l-17.9,0l0,17.9l18.6,18.6l18-18L20.9,2z M5.4,4.5l14.1,0l15.9,15.9L21.3,34.4L5.5,18.5L5.4,4.5z" />
              </svg>{" "}
              {frontmatter.tags.map(tag => (
                <Link
                  className="c-postTerms__link"
                  to={`/tag/${tag.slug}/`}
                  key={tag.slug}
                >
                  {tag.title}
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
      <PrevNext prev={pageContext.prev} next={pageContext.next} />
      <Author />
      <RelatedPosts posts={relatedPosts} />
    </footer>
  )
}

export default PostFooter
